import { useCallback, useEffect, useState } from 'react';
export function useScrollIntoViewOnMount(args = {}) {
  const {
    enabled = true,
    behavior = 'smooth',
    container
  } = args;
  const [node, setNode] = useState(null);
  const setRef = useCallback(element => {
    if (!enabled) {
      return;
    }
    setNode(element);
  }, [enabled]);
  useEffect(() => {
    if (!node) {
      return;
    }
    if (container && container.current === null) {
      return;
    }
    const wrapper = (container === null || container === void 0 ? void 0 : container.current) || window;
    const offsetY = 'getBoundingClientRect' in wrapper ? wrapper.getBoundingClientRect().top : 0;
    const {
      bottom,
      top,
      height
    } = node.getBoundingClientRect();
    const innerHeight = 'innerHeight' in wrapper ? wrapper.innerHeight : wrapper.clientHeight;
    const scrollY = 'scrollY' in wrapper ? wrapper.scrollY : wrapper.scrollTop - offsetY;
    if (top > 0 && bottom < innerHeight) {
      return;
    }
    const verticalCenter = top + scrollY + height / 2 - innerHeight / 2;
    wrapper.scrollTo({
      top: verticalCenter,
      behavior
    });
  }, [behavior, container, node]);
  return setRef;
}